import { Pipe, PipeTransform } from '@angular/core';
import { DataTranslationModel } from '@models/data-translation-model';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@services/language.service';

@Pipe({
	name: 'dataTranslate', pure: true, standalone: true
})
export class DataTranslatePipe implements PipeTransform {
	constructor(private languageService: LanguageService, translationService: TranslateService) {
	}

	transform(value: DataTranslationModel | string | undefined | null, ...args: any): string {
		let translateKey = "";

		if (value) {
			if (value instanceof DataTranslationModel) {
				if (value.TranslationKey && this.languageService.hasTranslation(value.TranslationKey)) {
					translateKey = value.TranslationKey;
				}
				else {
					translateKey = value.Fallback ?? '';
				}
			}
			else {
				translateKey = value;
			}
		}

		return translateKey;
	}
}
